/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedDate, useIntl } from 'react-intl'

import { EuiDescriptionList, EuiPanel, EuiSpacer, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { LineItem } from '@modules/billing-api/customTypes'

import { numericDateTime } from '@/config/dates'

const ActivitySection = ({ lineItem }: { lineItem: LineItem }) => {
  const { formatMessage } = useIntl()

  return (
    <EuiPanel paddingSize='m' color='subdued'>
      <EuiText size='s'>
        <h4>
          <FormattedMessage
            id='line-item.details-flyout.activity.title'
            defaultMessage='Activity'
          />
        </h4>
      </EuiText>
      <EuiSpacer />
      <EuiDescriptionList
        type='column'
        compressed={true}
        columnGutterSize='m'
        listItems={[
          {
            title: formatMessage({
              id: 'line-item.details-flyout.activity.start',
              defaultMessage: 'Start',
            }),
            description: <FormattedDate value={lineItem.start} {...numericDateTime} />,
          },
          {
            title: formatMessage({
              id: 'line-item.details-flyout.activity.expiry',
              defaultMessage: 'Expiry',
            }),
            description: <FormattedDate value={lineItem.end} {...numericDateTime} />,
          },
        ]}
      />
    </EuiPanel>
  )
}

export default ActivitySection
